import { render, staticRenderFns } from "./InlineBoxRelated.vue?vue&type=template&id=437b9adc"
import script from "./InlineBoxRelated.vue?vue&type=script&lang=js"
export * from "./InlineBoxRelated.vue?vue&type=script&lang=js"
import style0 from "./InlineBoxRelated.vue?vue&type=style&index=0&id=437b9adc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports